import React from 'react'
import { Link } from 'react-router-dom'
import { Navbar } from 'react-bootstrap';
import { Container } from 'react-bootstrap';
import { Nav } from 'react-bootstrap';
import { useState } from 'react';

import './Navbar.css'

function NavbarResponsive () {
  const isMobile = window.innerWidth <= 500
  const [expanded, setExpanded] = useState(false)
  
  if (isMobile) {
    return (
    <div className='bg' style={{position: 'relative', backgroundColor: 'black'}}>
      <Navbar variant="" expand="lg" expanded={expanded}>
        <Container>
          <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={() => setExpanded(expanded ? false : "expanded")}/>
            <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="mx-auto d-flex my-1">
              <Nav.Link onClick={() => setExpanded(false)}><Link to="/">WORK</Link></Nav.Link>
              <Nav.Link onClick={() => setExpanded(false)}><Link to="/about">ABOUT</Link></Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
    )
  }
  if (window.location.pathname === '/lumini' || 
      window.location.pathname === '/travel-fleek' || 
      window.location.pathname === '/about' ) {
    return (
      <div className='bg-desktop w-100'>
              <Nav>
                <Nav.Link><Link to="/" style={{color: 'black'}}>WORK</Link></Nav.Link>
                <Nav.Link><Link to="/about" style={{color: 'black'}}>ABOUT</Link></Nav.Link>
              </Nav>
      </div>
      )
  }
  else {
    return (
      <div className='bg-desktop w-100'>
              <Nav>
                <Nav.Link><Link to="/">WORK</Link></Nav.Link>
                <Nav.Link><Link to="/about">ABOUT</Link></Nav.Link>
              </Nav>
      </div>
      )
  }
}

export default NavbarResponsive